<template>
  <div class="main_content">
    <div class="breadcrumbs" />
    <div v-if="!loading" class="account">
      <config-bar class="account_bar" />
      <v-sheet class="account_main">
        <router-view></router-view>
      </v-sheet>
    </div>
  </div>
</template>

<script>
import ConfigBar from '@/views/account/ConfigBar.vue';
import { mapState } from 'vuex';

export default {
  name: 'Account',
  components: {
    ConfigBar,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({}),
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    $route: {
      handler: function (to, from) {
        this.handleRouteChange(to, from);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleRouteChange() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.account {
  display: flex;
  justify-content: space-between;
  flex: 1;
  height: 100%;
  &_main {
    height: 100%;
    margin-left: 32px;
    width: calc(100% - 372px);
    min-width: 740px;
  }
  &_full-height {
    height: 100%;
  }
  &_bar {
    display: flex;
    flex-direction: column;
    width: 340px;
    flex-grow: 0;
    flex-shrink: 0;
  }
}
</style>
